import { Text as e, Transforms as t } from "slate";
// lib/PrintText/lib/normalizePrintText.ts
var n = (n, r) => {
	let [i, a] = r;
	if ("type" in i && i?.type === "tt/print-text" && Array.isArray(i.children)) for (let r = 0; r < i.children.length; r++) {
		let o = i.children[r], s = a.concat(r);
		if (o.type === "tt/print-text/role" && Array.isArray(o.children)) for (let r = 0; r < o.children.length; r++) {
			let i = o.children[r], a = s.concat(r);
			if (e.isText(i)) {
				let e = i.text, r = e.replace(/[^a-z0-9-]/g, "");
				if (r !== e) return t.insertText(n, r, { at: a }), !0;
			}
		}
	}
};
export { n as normalizePrintText };
